import { IComponentController } from 'angular';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IStateParamsService, IStateService } from 'angular-ui-router';
import { IRoute } from '../../../../../core/interfaces/route.interface';

interface IPageAl2004 extends IComponentController {
    monoOccurrence: IMonoOccurrence;
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    dlcMultiOccurrenceOptions: IMultiOccurrenceOptions;
    ftpMultiOccurrence: IMultiOccurrence;
    ftpMultiOccurrenceOptions: IMultiOccurrenceOptions;
    formulaireCriteres: IFormulaire;
}

/* @ngInject */
export default function Al2004Controller(
    Formulaire: IFormulaireClass,
    $state: IStateService,
    as0017Route: IRoute,
    as0035Route: IRoute,
    FormulaireItem: IFormulaireItemClass,
    $stateParams: IStateParamsService
) {
    const vm: IPageAl2004 = this;


    vm.formulaireDLI =
        new Formulaire('LBL_DATE', [
            new FormulaireItem('vaedlitypdatald', { largeur: 10 }),
            new FormulaireItem('dlidatdeb', { largeur: 10 }),
            new FormulaireItem('dlidatfin', { largeur: 10 }),
            new FormulaireItem('nbrjrs', { largeur: 10  }),
            new FormulaireItem('dlicom', { largeur: 20 }),
            new FormulaireItem('dliseqmod', { largeur: 10 }),
            new FormulaireItem('dliflgact', { largeur: 10 })
        ]);

    vm.monoOccurrenceOptions = {
        formulaire: vm.formulaireDLI,
        reloadPage: true,
        successActionSauvegarde: () => {
            setTimeout(() => {
                $state.reload()
            }, 500);
        },
    }

    // Detail de la carence
    vm.dlcMultiOccurrenceOptions = {
        bloc: 'dlc', 
        resourceParamsDynamique: () => ({
            dlicleint: $stateParams.id
        }),
        fonctions: {
            importation: true
        },                 
        colonnesVisibles: [
            { nom: 'eplnummat', largeur: 225 },
            { nom: 'dlcdat', largeur: 105 },
            { nom: 'aftcod', largeur: 105 },
            { nom: 'aftdsc', largeur: 200 },
            { nom: 'actcod', largeur: 125 },
            { nom: 'actdsc', largeur: 200 },
            { nom: 'dlcqte', largeur: 105 }
        ],
        colonnesCachees: ['dlicleint'],
        formulaire: new Formulaire([
            new FormulaireItem('dlicleint', { default: $stateParams.id }),
            new FormulaireItem('dlcdat', { largeur: 10 }),
            new FormulaireItem('aftcleint', { largeur: 35,
                resourceParams: (rowData: any) => ({
                    dlicleint: rowData.dlicleint
                })
             }),
            new FormulaireItem('actcleint', { largeur: 30, resourceParams: (rowData: any) => ({
                dlicleint: rowData.dlicleint
            }) }),
            new FormulaireItem('dlcqte', { largeur: 10 })
        ])
    }

    // Feuille de temps
    vm.ftpMultiOccurrenceOptions = {
        bloc: 'ftp',  
        navigatePage: (rowData) => getForageItem(rowData), 
        navigateParams: (rowData: any) => ({
            id: rowData.trncleint
        }),
        colonnesCachees: ['trncleint','vaeatftyp', 'ptadatdeb', 'ptadatfin'],     
        colonnesVisibles: [
            { nom: 'atfnumdoc', largeur: 94 },
            { nom: 'ttcdsc', largeur: 200 },
            { nom: 'ptadsc', largeur: 170 },
            { nom: 'ppadsc', largeur: 150 },
            { nom: 'asgdsc', largeur: 240 },
            { nom: 'dtjdat', largeur: 120 },
            { nom: 'actcod', largeur: 120 },
            { nom: 'actdsc', largeur: 220 },            
            { nom: 'dtjqte', largeur: 120 }
        ]        
    }
    function getForageItem(rowData: any): string {
        if (rowData.vaeatftyp === 'JR' || rowData.vaeatftyp === 'AJR') {
            return as0017Route.NAME
        }
        if (rowData.vaeatftyp === 'PHR' || rowData.vaeatftyp === 'APHR') {
            return as0035Route.NAME
        }
    }       

}
